export const GET_TREE_PURCHASE_URL_START = 'TreePurchase/GET_TREE_PURCHASE_URL_START';
export const GET_TREE_PURCHASE_URL_SUCCESS = 'TreePurchase/GET_TREE_PURCHASE_URL_SUCCESS';
export const GET_TREE_PURCHASE_URL_FAILURE = 'TreePurchase/GET_TREE_PURCHASE_URL_FAILURE';
